
import { defineComponent } from 'vue';
import { epicDataComposition, epicSectionsComposition } from '../../services';
import { overlayComposition } from '@/core/modules/overlay/services';
import { toKebabCaseId } from '@/core/services/core.utils';

export default defineComponent({
    setup () {
        const datum = epicDataComposition();

        return { 
            ...epicDataComposition(), ...epicSectionsComposition(datum), toKebabCaseId,
            ...overlayComposition()
        };
    }
})
